import { MessageTypeSelect, SettingsSectionHeader } from '../common';
import { WebPushBodyField } from './formFields/WebPushBodyField';
import { DataFeedsFormSection } from '../common/DataFeedsFormSection';
import { WebPushTitleField } from './formFields/WebPushTitleField';
import { WebPushIconField } from './formFields/WebPushIconField';
import { WebPushLocationField } from './formFields/WebPushLocationField';
import { displayContent } from '../common/content';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateNameField } from '../common/TemplateNameField';

export const SettingsForm = () => {
  const { campaignId } = useQueryParamContext();
  const isCampaignFlow = !!campaignId;

  return (
    <>
      {isCampaignFlow && (
        <>
          <SettingsSectionHeader>{displayContent.templateInformation}</SettingsSectionHeader>
          <TemplateNameField />
        </>
      )}

      <SettingsSectionHeader>{displayContent.headerSendingInformation}</SettingsSectionHeader>
      <MessageTypeSelect />
      <SettingsSectionHeader>{displayContent.headerContent}</SettingsSectionHeader>
      <WebPushTitleField />
      <WebPushBodyField />
      <WebPushIconField />
      <DataFeedsFormSection />
      <SettingsSectionHeader>{displayContent.headerBehavior}</SettingsSectionHeader>
      <WebPushLocationField />
    </>
  );
};

export default SettingsForm;
